import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "label", "tokens", "placement", "offset", "withArrow", "delay", "idleTargetOpacity"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useRef, useState } from 'react';
import { useDismiss, useFloating, useFocus, useHover, useInteractions, useRole, offset, flip, shift, autoUpdate, arrow, FloatingArrow, useTransitionStyles } from '@floating-ui/react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Tooltip.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BaseTooltip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      label = _ref.label,
      tokens = _ref.tokens,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "right" : _ref$placement,
      _ref$offset = _ref.offset,
      offsetNumber = _ref$offset === void 0 ? 10 : _ref$offset,
      _ref$withArrow = _ref.withArrow,
      withArrow = _ref$withArrow === void 0 ? true : _ref$withArrow,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 200 : _ref$delay,
      idleTargetOpacity = _ref.idleTargetOpacity,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var arrowRef = useRef(null);

  var _useFloating = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: placement,
    whileElementsMounted: autoUpdate,
    middleware: [offset(offsetNumber), flip({
      fallbackAxisSideDirection: "start"
    }), shift(), arrow({
      element: arrowRef
    })]
  }),
      refs = _useFloating.refs,
      floatingStyles = _useFloating.floatingStyles,
      context = _useFloating.context;

  var hover = useHover(context, {
    move: false,
    delay: delay
  });
  var focus = useFocus(context);
  var dismiss = useDismiss(context);
  var role = useRole(context, {
    role: "tooltip"
  });

  var _useTransitionStyles = useTransitionStyles(context, {
    duration: delay
  }),
      isMounted = _useTransitionStyles.isMounted,
      styles = _useTransitionStyles.styles;

  var _useInteractions = useInteractions([hover, focus, dismiss, role]),
      getReferenceProps = _useInteractions.getReferenceProps,
      getFloatingProps = _useInteractions.getFloatingProps;

  return _jsxs(views.Container, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [_jsx(views.Target, _objectSpread(_objectSpread({
      ref: refs.setReference,
      opacity: isOpen ? 1 : idleTargetOpacity !== null && idleTargetOpacity !== void 0 ? idleTargetOpacity : 1
    }, getReferenceProps()), {}, {
      children: children
    })), isMounted && _jsxs(views.Tooltip, _objectSpread(_objectSpread(_objectSpread({
      ref: refs.setFloating,
      style: _objectSpread(_objectSpread({}, floatingStyles), styles)
    }, tokens), getFloatingProps()), {}, {
      children: [label, withArrow && _jsx(FloatingArrow, {
        ref: arrowRef,
        context: context,
        fill: tokens.backgroundColor,
        "data-testid": "tooltip-arrow"
      })]
    }))]
  }));
});
export var Tooltip = withDesignTokens(BaseTooltip, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      color: theme.palette.twilio.gray[60],
      backgroundColor: theme.palette.neutrals.white[100]
    };
  },
  light: function light(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      backgroundColor: theme.palette.twilio.gray[60]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      backgroundColor: theme.palette.twilio.gray[60]
    };
  }
});